import { Component, OnInit, Input } from '@angular/core';
import { StationService } from 'src/app/api/station.service';
import { StationDetail } from 'src/app/models/api_models/station';
import { LeafletMapStationZoomComponent } from 'src/app/leaflet/leaflet-map-station-zoom/leaflet-map-station-zoom.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-station-main-info',
  templateUrl: './station-main-info.component.html',
  styleUrls: ['./station-main-info.component.scss']
})
export class StationMainInfoComponent implements OnInit {
  
  private _station : StationDetail = null;
  get station() : StationDetail {
    return this._station;
  }
  @Input()
  set station(station : StationDetail) {
    this._station = station;
  }

  displayLeafletDialog() {
    this.dialog.open(LeafletMapStationZoomComponent, {
      data: null,
    });
  }

  private _stationId : number = null;
  get stationId() : number {
    return this._stationId;
  }
  @Input()
  set stationId(stationId : number) {
    this._stationId = stationId;
    if (this._stationId != null) {
      this.stationService.getStationDetailFromId(this._stationId).subscribe(
        response => {
          this._station = response;
        });
    }
  }


  constructor(private stationService : StationService, public dialog: MatDialog) { }

  ngOnInit() {
  }

}
